<template>
  <yxt-form
    ref="labelform"
    :show-message="true"
    :hide-required-asterisk="true"
    :model="value"
    :inline="true"
    class="label-rule"
  >
    <!-- 开发异常显示 -->
    <yxt-form-item
      size="small"
      prop="id"
      :error="
        value.state === 1 || value.state === 2 || value.state === 3 ? ' ' : ''
      "
      :rules="{
        required: true,
        message: $t('pc_spmodel_biz_1'),
        trigger: ['blur', 'change']
      }"
    >
      <yxt-select
        v-if="value"
        v-model="value.id"
        @change="chooseFn2($event)"
        :placeholder="$t('pc_spmodel_biz_select')"
        filterable
        clearable
        size="small"
        class="yxt-dimension-label-select mr12"
      >
        <yxt-option
          v-for="(option, j) in type2"
          v-show="option.disabled === 0"
          :key="j"
          :label="option.name"
          :disabled="option.disabled === 1"
          :value="option.id"
        />
      </yxt-select>
    </yxt-form-item>
    <template v-if="value" v-for="(it, k) in value.operators">
      <yxt-form-item
        size="small"
        :prop="'operators.' + k + '.operateType'"
        :rules="{
          required: true,
          message: $t('pc_spmodel_biz_2'),
          trigger: ['blur', 'change']
        }"
      >
        <yxt-select
          v-model="it.operateType"
          @change="chooseFn11(k, $event)"
          :filterable="true"
          :placeholder="$t('pc_spmodel_biz_select')"
          clearable
          size="small"
          class="yxt-dimension-label-select mr12"
        >
          <yxt-option
            v-for="(option, j) in laberlist[1]"
            :key="j"
            :label="$t(option.operatorCnName)"
            :value="option.operateType"
          />
        </yxt-select>
      </yxt-form-item>

      <!-- 第四层 -->
      <yxt-form-item
        size="small"
        v-if="[1, 2, 3, 4, 5, 6].includes(Number(it.operateType))"
        :prop="'operators.' + k + '.value.id'"
        :error="it.state === 4 ? ' ' : ''"
        :key="it.value.id"
        :rules="{
          required: true,
          message: $t('pc_spmodel_biz_3'),
          trigger: ['blur', 'change']
        }"
      >
        <yxt-select
          v-model="it.value.id"
          @change="chooseFn22(k, $event, 1)"
          :placeholder="$t('pc_spmodel_biz_select')"
          filterable
          clearable
          size="small"
          class="w124 mr12"
        >
          <yxt-option
            v-for="(opt, l) in labervalue"
            v-show="opt.deleted === 0"
            :key="l"
            :disabled="opt.deleted === 1"
            :label="opt.labelValue"
            :value="opt.labelValueId"
          />
        </yxt-select>
      </yxt-form-item>
      <yxt-form-item
        size="small"
        v-if="[7, 8, 9].includes(Number(it.operateType))"
        :prop="'operators.' + k + '.values'"
        :key="it.operateType"
        :error="it.state === 4 ? ' ' : ''"
        :rules="[
          {
            type: 'array',
            required: true,
            message: $t('pc_spmodel_biz_3'),
            trigger: ['blur', 'change']
          }
        ]"
      >
        <yxt-select
          v-model="it.values"
          :key="it.operateType"
          ref="muselect"
          @change="chooseFn22(k, $event, 2)"
          :placeholder="$t('pc_spmodel_biz_select')"
          multiple
          collapse-tags
          filterable
          clearable
          size="small"
          class="w216 mr12"
        >
          <yxt-option
            v-for="(opt, l) in labervalue"
            v-show="opt.deleted === 0"
            :label="opt.labelValue"
            :disabled="opt.deleted === 1"
            :key="l"
            :value="opt.labelValueId"
          />
        </yxt-select>
      </yxt-form-item>
    </template>
  </yxt-form>
</template>

<script>
import { laberlist } from './enum';
import { getLabelList } from '../service.js';
export default {
  name: 'LabelRule',
  data() {
    return {
      laberlist,
      labervalue: []
    };
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          type: '',
          columnType: '',
          id: '',
          name: '',
          description: '',
          operators: [],
          state: 0
        };
      }
    },
    uselocalStorage: {
      type: Boolean,
      default: false
    },
    type2: {
      type: Array,
      default: []
    }
  },
  watch: {
    type2: {
      handler() {
        // 处理默认赋值时候的下拉选项问题
        if (this.type2.length > 0 && this.value) {
          this.type2.forEach(item => {
            if (this.value.id === item.id) {
              this.labervalue = item.labelValueList;
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // if (this.type2.length > 0) {
    //   this.getLabelListFn();
    // }
    if (this.value && this.value.operators) {
      this.value.operators.forEach(item => {
        if (item.value && !Array.isArray(item.value)) {
          item.values = item.value;
          item.state = item.value.state;
        } else if (item.value && Array.isArray(item.value)) {
          let valuearry = [];
          let state = 0;
          item.value.forEach(obj => {
            valuearry.push(obj.id);
            if (obj.state !== 0) {
              state = obj.state;
            }
          });
          setTimeout(() => {
            item.values = valuearry;
          });
          item.state = state;
        }
      });
      console.log(this.value);
    }
    if (this.value && this.value.operators) {
      this.value.operators.forEach(item => {
        if (item.value) {
          item.values = item.value;
        }
      });
    }
  },
  methods: {
    chooseFn2(i) {
      let j = {
        id: '',
        name: '',
        labelValueList: ''
      };
      this.type2.forEach(item => {
        if (item.id === i) {
          j = item;
        }
      });
      let newValue = JSON.parse(JSON.stringify(this.value));
      newValue.id = j.id || '';
      newValue.name = j.name || '';
      newValue.description = j.description;
      newValue.operators[0].operateType = '';
      newValue.operators[0].operatorCnName = '';
      newValue.operators[0].value = [];
      newValue.operators[0].values = [];
      newValue.state = 0;
      this.labervalue = j.labelValueList || '';
      this.$emit('update:value', newValue);
    },
    getLabelListFn() {
      if (this.uselocalStorage && localStorage.getItem('labelList')) {
        this.type2 = JSON.parse(localStorage.getItem('labelList'));
        return;
      }
      getLabelList({}).then(res => {
        if (res && res.length > 0) {
          this.type2 = res;
          localStorage.setItem('labelList', JSON.stringify(this.type2));
        }
      });
    },
    //     标签：7-包含其一、8-不包含、9-全部包含、1-等于、3-大于、4-小于、5-大于等于、6-小于等于
    chooseFn22(k, j, type) {
      console.log(this.labervalue);
      let newValue = JSON.parse(JSON.stringify(this.value));
      if (type === 1) {
        let jother = {};
        // 循环匹配勾选上的对象
        this.labervalue.forEach(item => {
          if (item.labelValueId === j) {
            jother = {
              name: item.labelValue,
              id: item.labelValueId
            };
          }
        });
        newValue.operators[k].value = jother;
      } else {
        if (Array.isArray(j)) {
          let jother = [];
          // 双重循环匹配勾选上的对象
          this.labervalue.forEach(item => {
            j.forEach(other => {
              if (item.labelValueId === other) {
                jother.push({
                  name: item.labelValue,
                  id: item.labelValueId
                });
              }
            });
          });
          newValue.operators[k].value = jother;
        }
      }
      console.log(newValue);
      this.$emit('update:value', newValue);
    },
    chooseFn11(k, j) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      newValue.operators[k].value = [7, 8, 9].includes(Number(j.operateType))
        ? [{ name: '', id: null }]
        : { name: '', id: null };
      newValue.operators[k].values = [];
      let operatorCnName = '';
      this.laberlist[1].forEach(item => {
        if (item.operateType === j) {
          operatorCnName = item.operatorCnName;
        }
      });
      newValue.operators[k].operatorCnName = operatorCnName;
      newValue.operators[k].operateType = j;
      this.$emit('update:value', newValue);
    },
    validateFn() {
      return this.$refs.labelform.validate();
    }
  }
};
</script>
<style lang="scss" scoped>
.label-rule {
  display: inline-block;
  vertical-align: top;
}

.yxt-dimension-label-select {
  width: 114px;
}

.w124 {
  width: 124px;
}

.w216 {
  width: 216px;
}
</style>
